/**
 * LayoutContext - Shared state for the layout system
 */

import { createContext, useContext } from 'react';

export interface PanelConfig {
  width: number;
  collapsed: boolean;
  minWidth?: number;
  maxWidth?: number;
}

export interface LayoutState {
  leftPanel: PanelConfig;
  rightPanel: PanelConfig;
}

export interface LayoutContextValue {
  state: LayoutState;
  updateLeftPanel: (updates: Partial<PanelConfig>) => void;
  updateRightPanel: (updates: Partial<PanelConfig>) => void;
  toggleLeftPanel: () => void;
  toggleRightPanel: () => void;
  isInteractingWithUI: boolean;
  setIsInteractingWithUI: (isInteracting: boolean) => void;
}

export const LayoutContext = createContext<LayoutContextValue | null>(null);

export const useLayout = (): LayoutContextValue => {
  const context = useContext(LayoutContext);
  if (!context) {
    // Return default values instead of throwing - allows components to render
    // outside of AppContainer during early initialization
    return {
      state: {
        leftPanel: { width: 300, collapsed: false },
        rightPanel: { width: 300, collapsed: false }
      },
      updateLeftPanel: () => {},
      updateRightPanel: () => {},
      toggleLeftPanel: () => {},
      toggleRightPanel: () => {},
      isInteractingWithUI: false,
      setIsInteractingWithUI: () => {}
    };
  }
  return context;
};
